module.exports = __webpack_public_path__ + "static/media/noentry.821ad8ab.jpg";